import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var TissueBiopsyTestRes;
export const TissueBiopsyTestTodo = createAsyncThunk('TissueBiopsyTest', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: "http://192.168.1.122:5001/tissue_bio_analysis",
            data: {
                'biopsy_site': data.biopsy_site,
                'cell_morphology': data.cell_morphology,
                'malignant_cell_type': data.malignant_cell_type,
                'tissue_architecture': data.tissue_architecture,
                'inflammation_type': data.inflammation_type,
                'inflammation_severity': data.inflammation_severity,
                'necrosis_extent': data.necrosis_extent,
                'fibrosis_extent': data.fibrosis_extent,
                'sample_size': parseFloat(data.sample_size),
                'staining_method': data.staining_method,
                'inflammation_presence': parseInt(data.inflammation_presence),
                'necrosis_presence': parseInt(data.necrosis_presence),
                'fibrosis_presence': parseInt(data.fibrosis_presence),
                // "company_id":localStorage.getItem('companyId')
            },
            headers: { "Content-Type": "application/json", }
        })
        return TissueBiopsyTestRes = res.data

    } catch (error) {
        return TissueBiopsyTestRes = error.response.data
    }
})